import { prepareCommonCarriageData, sendCarriage } from "~/features/configurator/Carriage/api/sendCarriageCommon";
import { type LinearConfiguration } from "~/features/configurator/Linear/models";
import {
  prepareApiDataForResetNew,
  prepareApiDataForResetNewest,
  prepareGroupIdToDisplay,
} from "~/features/configurator/common/commonConfiguratorApi";
import { type LinearConfiguratorState } from "~/features/configurator/Linear/redux/types";
import { ConfiguratorType } from "~/domains/configurator/types/ConfiguratorType";
import { transform } from "~/features/configurator/Linear/linearDataTransformer";
import { KWLT_CARRIAGE_CONFIGURATOR_PRODUCT_CODE } from "~/domains/configurator/constants";

export async function sendCarriageDataReset(linearState: LinearConfiguratorState): Promise<LinearConfiguration> {
  const data = prepareCommonCarriageData(linearState);
  const productCode = linearState.productCode;

  const resetData =
    productCode === KWLT_CARRIAGE_CONFIGURATOR_PRODUCT_CODE
      ? prepareApiDataForResetNewest(linearState)
      : prepareApiDataForResetNew(linearState);

  prepareGroupIdToDisplay(data);

  // For Step 3 - we need to send a special flag to reload the default values for the carriage details substep
  if (linearState.currentStep === 2) {
    data.carriagesConfiguratorData.enableConfigureCarriageValues = false;
  }

  const response = await sendCarriage({
    ...data,
    ...resetData,
  });
  return transform(response, ConfiguratorType.Carriage, undefined);
}
